<template>
  <div class="wrapper" style="background-color: #ffffff">
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <notifications></notifications>

    <div class="section">
      <div class="container">
        <div
          class="md-layout md-alignment-center-center"
          v-if="form.multilang === 1"
        >
          <lang />
        </div>
        <div class="md-layout md-alignment-center-center">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <div style="text-align: center">
              <a :href="headerimagelink" target="_blank">
                <img :src="headerpicture" alt="" />
              </a>
            </div>
          </div>
        </div>
        <div v-if="form.used === 0 && sent === 0">
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-small-size-100 md-size-50">
              <h3 class="text-center form-header">
                {{ langtext(form.description) }}
              </h3>
            </div>
          </div>
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-small-size-100 md-size-50">
              <questions
                ref="qcontrol"
                :linkid="id"
                :headerpicture="headerpicture"
                :backpicture="backpicture"
              />
              <br />
            </div>
          </div>
          <div class="md-layout md-gutter md-alignment-center-center">
            <div
              class="md-layout-item md-small-size-100 md-size-50"
              style="text-align: center"
            >
              <md-button
                v-if="formloaded"
                class="md-raised mt-4 md-send"
                :class="formstyle.buttonround"
                @click="onValidate"
                >{{ sendcaption }}</md-button
              >
            </div>
          </div>
          <a href="https://huestimates.com" target="_blank">
            <div style="text-align: center">
              <h4 class="md-title">
                <span style="font-size: 10pt; color: black; font-weight: 100"
                  >powered by</span
                >&nbsp;
                <img src="logo1.png" width="100px" />
              </h4>
            </div>
          </a>
        </div>
        <div v-if="sent === 1 || form.used === 1">
          <h2 class="text-center thanks-title">{{ thankyou }}</h2>

          <h5 v-if="form.used === 0" class="text-center">
            <md-icon v-if="negative === 1" class="text-warning"
              >warning</md-icon
            >
            <span v-html="langtext(finishtext)" />
          </h5>
          <h5 v-if="form.used === 1" class="text-center">
            {{ alreadyanswered }}
          </h5>
          <div v-if="sociallink">
            <iframe
              :src="sociallink"
              width="100%"
              height="100px"
              frameborder="0"
              scrolling="no"
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-33">
        <div class="modal modal-bg" :class="{ show: modalVisible }">
          <modal v-if="modalVisible">
            <template slot="header">
              <h4 class="modal-title">{{ addinfo }}</h4>
              <md-button
                class="md-simple md-close md-just-icon md-round modal-default-button"
                @click="modalVisible = false"
              >
                <md-icon>clear</md-icon>
              </md-button>
            </template>

            <template slot="body">
              <div class="container">
                <respondent
                  ref="askdet"
                  :detail="{
                    visible: form.askdetails,
                    required: form.askdetailsrequired,
                  }"
                />
              </div>
            </template>

            <template slot="footer">
              <div class="text-center" style="text-align: center">
                <md-button
                  @click="onSave(true)"
                  class="md-send"
                  :class="formstyle.buttonround"
                  >{{ sendcaption }}</md-button
                >
              </div>
            </template>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileUrl, askdetempty } from "../services/helper";
import {
  GetPublicForm,
  FormVisit,
  Feedback,
  GetFormStyle,
} from "../services/react";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Questions from "./components/Questions";
import Respondent from "./components/Respondent";
import { Modal } from "@/components";
import Lang from "./components/Lang.vue";
export default {
  components: {
    Questions,
    Loading,
    Respondent,
    Modal,
    Lang,
  },
  props: {
    id: String,
  },
  computed: {
    uploadurl() {
      return uploadUrl;
    },
    fileurl() {
      return fileUrl;
    },
    headerpicture() {
      return !this.form.headerpicture
        ? ""
        : this.fileurl + this.form.headerpicture;
    },
    backpicture() {
      return !this.form.backpicture ? "" : this.fileurl + this.form.backpicture;
    },
    headerimagelink() {
      return !this.formstyle ? "" : this.formstyle.headerimagelink;
    },
    sociallink() {
      return !this.formstyle ? "" : this.formstyle.sociallink;
    },
    sendcaption() {
      return this.$store.getters.langindex === 1 ? "Send" : "Göndər";
    },
    alreadyanswered() {
      return this.$store.getters.langindex === 1
        ? "You have already left a review!"
        : "Sorğu artıq cavablandırılıb!";
    },
    thankyou() {
      return this.$store.getters.langindex === 1
        ? "Thank you!"
        : "Təşəkkür edirik!";
    },
    addinfo() {
      return this.$store.getters.langindex === 1
        ? "Additional info"
        : "Əlavə məumat";
    },
    requiredfield() {
      return this.$store.getters.langindex === 1
        ? "Please fill required fields!"
        : "Zəhmət olmasa, mütləq xanaları qeyd edin!";
    },
  },
  data() {
    return {
      isLoading: false,
      form: {},
      questions: [],
      sent: 0,
      negative: 0,
      modalVisible: false,
      finishtext: "",
      formstyle: {},
      formloaded: false,
    };
  },
  methods: {
    getForm() {
      this.isLoading = true;
      GetPublicForm(this.id).then((response) => {
        if (response.data.result !== undefined) {
          this.isLoading = false;
          this.form = response.data.result;
          GetFormStyle(this.id, "PUBLIC").then((response) => {
            if (response.data.result) {
              this.formstyle = response.data.result;
              this.applystyle();
            }
            this.formloaded = true;
          });
        } else {
          this.isLoading = false;
          this.notifyVue("danger", response.data);
        }
      });
    },
    onValidate() {
      let valid = this.$refs.qcontrol.validate();
      if (valid) {
        let negative = this.$refs.qcontrol.isNegative();
        let commented = this.$refs.qcontrol.commented();
        if (
          this.form.askdetails !== askdetempty &&
          (this.form.askdetailscase === 1 ||
            (this.form.askdetailscase === 2 && negative) ||
            (this.form.askdetailscase === 3 && commented))
        ) {
          this.modalVisible = true;
        } else this.finish();
      } else {
        this.notifyVue("danger", this.requiredfield);
      }
    },
    onSave() {
      this.$refs.askdet.isvalid().then((isValid) => {
        if (isValid) {
          this.modalVisible = false;
          this.finish();
        } else {
          this.notifyVue("danger", this.requiredfield);
        }
      });
    },
    finish() {
      let feedback = {};
      // if (this.form.askdetails !== askdetempty) {
      //   feedback = this.$refs.askdet.value();
      // }
      if (this.$refs.askdet) feedback = this.$refs.askdet.value();

      feedback.linkid = this.id;
      feedback.answers = this.$refs.qcontrol.value();
      feedback.negative = this.$refs.qcontrol.isNegative() ? 1 : 0;
      feedback.commented = this.$refs.qcontrol.commented() ? 1 : 0;
      this.negative = feedback.negative;
      this.isLoading = true;
      Feedback(feedback).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.finishtext = response.data.result.finishtext;
          this.sent = 1;
        } else {
          this.notifyVue("danger", "Action failed!");
        }
      });
    },
    visit() {
      FormVisit(this.id).then();
    },
    applystyle() {
      if (this.formstyle) {
        let root = document.documentElement;
        root.style.setProperty(
          "--header-color",
          this.formstyle.headertextcolor
        );
        root.style.setProperty("--header-size", this.formstyle.headertextsize);
        root.style.setProperty("--header-bold", this.formstyle.headertextbold);

        root.style.setProperty("--divider-size", this.formstyle.dividersize);
        root.style.setProperty("--divider-color", this.formstyle.dividercolor);
        root.style.setProperty(
          "--question-color",
          this.formstyle.questiontextcolor
        );
        root.style.setProperty(
          "--question-size",
          this.formstyle.questiontextsize
        );
        root.style.setProperty(
          "--question-bold",
          this.formstyle.questiontextbold
        );

        root.style.setProperty("--radio-color", this.formstyle.radiocolor);
        root.style.setProperty(
          "--input-border-color",
          this.formstyle.inputactivecolor
        );
        root.style.setProperty(
          "--input-border-size",
          this.formstyle.inputbordersize
        );
        root.style.setProperty("--dropdown-color", this.formstyle.radiocolor);
        root.style.setProperty("--check-color", this.formstyle.checkcolor);
        root.style.setProperty(
          "--send-button-color",
          this.formstyle.buttoncolor
        );

        root.style.setProperty(
          "--thanks-text-color",
          this.formstyle.thankstextcolor
        );
        root.style.setProperty(
          "--thanks-text-size",
          this.formstyle.thankstextsize
        );
        root.style.setProperty(
          "--thanks-text-bold",
          this.formstyle.thankstextbold
        );
      }
    },
  },
  mounted() {
    this.getForm();
    this.visit();
  },
};
</script>

<style>
body {
  font-variant-ligatures: no-common-ligatures;
}
:root {
  --header-color: "";
  --header-size: "";
  --header-bold: "";
  --divider-color: "";
  --divider-size: "";
  --question-color: "";
  --question-size: "";
  --question-bold: "";

  --radio-color: "";
  --input-border-color: "";
  --input-border-size: "";
  --send-button-color: "";
  --thanks-text-color: "";
  --thanks-text-size: "";
  --thanks-text-bold: "";
}
.form-header {
  color: var(--header-color);
  font-size: var(--header-size);
  font-weight: var(--header-bold);
}

.thanks-title {
  color: var(--thanks-text-color);
  font-size: var(--thanks-text-size);
  font-weight: var(--thanks-text-bold);
}

.mt-3 {
  margin-top: 1.875rem * 2;
}
.mb-0 {
  margin-bottom: 0;
}
.md-menu-content {
  z-index: 99999 !important;
}

#iframe {
  display: block;
  width: 100%;
  height: 100%;
}
.section {
  padding-top: 10px !important;
}
</style>
